<template>
<div>
  <h3>Persönliche Angaben</h3>
  <div class="row">
    <div class="col-24 col-lg-8">
      <contact-select name="salutation" label="Anrede" group="contact" values="Frau,Herr" placeholder="Anrede"></contact-select>
    </div>
    <div class="col-24 col-lg-16">
      <contact-input name="name" label="Vor- und Nachname" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-9">
      <contact-input name="street" label="Straße, Haus-Nr." group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-6">
      <contact-input name="zip" label="PLZ" group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-9">
      <contact-input name="city" label="Ort" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-8">
      <contact-input name="phone" label="Telefon" group="contact"></contact-input>
    </div>
    <div class="col-24 col-lg-16">
      <contact-input name="email" label="E-Mail" group="contact"></contact-input>
    </div>
  </div>

  <h3>Versandadresse (falls abweichend)</h3>
  <div class="row">
    <div class="col-24 col-lg-8">
      <contact-select name="versandSalutation" label="Anrede" group="contact" values="Frau,Herr" placeholder="Anrede"></contact-select>
    </div>
    <div class="col-24 col-lg-16">
      <contact-input name="versandName" label="Vor- und Nachname" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-9">
      <contact-input name="versandStreet" label="Straße, Haus-Nr." group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-6">
      <contact-input name="versandZip" label="PLZ" group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-9">
      <contact-input name="versandCity" label="Ort" group="contact"></contact-input>
    </div>
  </div>

  <h3>Bestellung für die Miet-, Sondermiet- und WEG-Verwaltung</h3>
  <div class="row">
    <div class="col-24 col-lg-6">
      <contact-input name="objectNumber" group="contact" label="Nr."></contact-input>
    </div>

    <div class="col-24 col-lg-11">
      <contact-input name="object" group="contact" label="Objekt"></contact-input>
    </div>

    <div class="col-24 col-lg-7">
      <contact-select name="objectKeys" label="Menge Schlüssel" group="contact" values="1,2,3,4,5,6,7,8,9,10" placeholder="Menge Schlüssel"></contact-select>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-8">
      <contact-input name="objectDistrict" label="Ort" group="contact"></contact-input>
    </div>
    <div class="col-24 col-lg-16">
      <contact-input name="objectName" label="Nahme der Wohnanlage" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-14">
      <p>Durch wen erfolgt die Bestellung?</p>
    </div>

    <div class="col-24 col-lg-10">
      <contact-select name="objectBoughtBy" label="Bitte auswählen" group="contact" values="Eigentümer,Mieter" placeholder="Bitte auswählen"></contact-select>
    </div>
  </div>

  <h3>Angaben zum Schlüssel</h3>
  <div class="row">
    <div class="col-24 col-lg-12">
      <contact-input name="keyDescription" label="Bezeichnung" group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-12">
      <contact-input name="keyCompany" label="Schliessanlagenfirma" group="contact"></contact-input>
    </div>
  </div>

  <div>
    <contact-input name="keyNumber" label="Schlüsselnummer" group="contact"></contact-input>
  </div>

  <div class="row">
    <div class="col-24 col-lg-12">
      <contact-input name="keyFront1" label="Vorderseite Zeile 1" group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-12">
      <contact-input name="keyFront2" label="Vorderseite Zeile 2" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24 col-lg-12">
      <contact-input name="keyBack1" label="Rückseite Zeile 1" group="contact"></contact-input>
    </div>

    <div class="col-24 col-lg-12">
      <contact-input name="keyBack2" label="Rückseite Zeile 2" group="contact"></contact-input>
    </div>
  </div>

  <div class="row">
    <div class="col-24">
      <v-radio-group v-model="contactType" row label="Kontaktaufnahme per: " class="my-0 py-0" :hide-details="true">
        <v-radio hide-details label="E-Mail" value="E-Mail" off-icon="fal fa-circle" on-icon="far fa-dot-circle"></v-radio>
        <v-radio hide-details label="Telefon" value="Telefon" off-icon="fal fa-circle" on-icon="far fa-dot-circle"></v-radio>
      </v-radio-group>
    </div>
  </div>

</div>
</template>

<script>
import ContactInput from "./ContactInput.vue";
import ContactSelect from "./ContactSelect.vue";

export default {
  name: "SchluesselbestellungForm",

  components: {
    ContactInput,
    ContactSelect
  },

  methods: {
    contactType(val) {
      this.$root.contactForm.contact.contactType = val;
    }
  }
}
</script>
